export default (state = {}, action) => {
  switch (action.type) {
    case 'USERS_FETCH_SUCCESS':
      return {
        ...state,
        users: action.users
      };
    default:
      return state;
  }
}


/** WEBPACK FOOTER **
 ** ./src/reducers/usersReducers.js
 **/